import { StyledModal } from '@app/components/modal/Modal';
import useNumberActions from '@app/hooks/numbers/useNumberActions';
import type { AINumber } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type AgentDeleteModalProps = ModalProps & {
    title?: string;
    data?: AINumber;
};

export const AgentDeleteModal = ({
    title = 'Delete Ai Agent?',
    data,
    ...props
}: AgentDeleteModalProps) => {
    const { deleteNumber } = useNumberActions();

    return (
        <StyledModal
            title={title}
            maskClosable={false}
            okText="Delete"
            {...props}
            confirmLoading={deleteNumber?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteNumber.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this AI agent?</p>
        </StyledModal>
    );
};

export default AgentDeleteModal;
